import Constants from '../../../app/utils/constants'
import TitleHeader from '../../atoms/TitleHeader/TitleHeader'
import Card from './Card'

import chooseus from '../../../assets/images/homepage/chooseus/chooseus.webp'
import googleicon from '../../../assets/images/homepage/chooseus/googleicon.webp'
import SearchIcon from '../../../assets/images/icons/searchicon.svg'

import { useEffect, useRef, useState } from 'react'

const ChooseUs = () => {
  const { chooseUsCards } = Constants

  const sectionRef = useRef<HTMLDivElement>(null)
  const ref = useRef(null)

  const [isInView, setIsInView] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsInView(entry.isIntersecting)
      },
      { threshold: 0.2 }
    )

    if (ref.current) observer.observe(ref.current)

    return () => observer.disconnect()
  }, [])

  return (
    <div
      ref={sectionRef}
      className="relative h-auto overflow-hidden bg-cover bg-center bg-no-repeat px-4 sm:px-6 md:px-8 lg:px-10 xl:px-14 2xl:px-20 py-12 md:py-16 lg:py-20"
      style={{ backgroundImage: "url({choosusbgg})" }}
    >

      {/* MAIN CONTAINER */}
      <div className="relative z-10 flex flex-col lg:flex-row items-center justify-between gap-10 lg:gap-8 xl:gap-14 2xl:gap-20">

        {/* ================= LEFT SIDE ================= */}
        <div className="w-full lg:w-[52%] xl:w-1/2 flex flex-col font-rajdhani font-semibold md:gap-5 lg:gap-6">

<TitleHeader
  badgeText="CHOOSE US"
  titleLines={[
    'Why Leading Companies',
    'Choose',
    'The Coding Studio',
  ]}
/>
          {/* CARDS */}
          <div ref={ref} className="flex flex-col gap-4 lg:gap-5 mt-6 md:mt-0">

            {chooseUsCards.map((item, i) => (
              <div
                key={i}
                className={`transition-all duration-700 ease-in ${
                  isInView
                    ? 'translate-x-0 opacity-100'
                    : '-translate-x-40 opacity-0'
                }`}
                style={{
                  transitionDelay: `${i * 250}ms`,
                }}
              >
                <Card {...item} />
              </div>
            ))}

          </div>
        </div>

        {/* ================= RIGHT SIDE ================= */}
        <div className="hidden lg:flex relative w-[45%] xl:w-1/2 items-center justify-center h-[500px] xl:h-[600px] 2xl:h-[620px]">

          <div className="relative z-10 w-[320px] lg:w-[360px] xl:w-[470px] 2xl:w-[500px]">

            {/* PURPLE CIRCLE */}
            <div className="absolute z-0 h-[260px] w-[260px] lg:h-[300px] lg:w-[300px] xl:h-[370px] xl:w-[370px] 2xl:h-[440px] 2xl:w-[440px] -top-[8%] left-[19%] rounded-full bg-purple" />

            {/* MAIN IMAGE */}
            <img
              src={chooseus}
              alt="main"
              className="relative z-10 w-full h-auto object-contain"
            />

            {/* GOOGLE ICON */}
            <>
              <style>
                {`
                  @keyframes tilt {
                    0% { transform: rotate(0deg); }
                    50% { transform: rotate(10deg); }
                    100% { transform: rotate(0deg); }
                  }
                `}
              </style>

              <img
                src={googleicon}
                alt="google icon"
                className="absolute -top-10 -right-8 lg:-top-12 lg:-right-13 xl:-top-16 xl:-right-18 2xl:-top-10 2xl:-right-30 w-16 lg:w-20 xl:w-24 2xl:w-28 z-20 animate-[tilt_2.5s_ease-in-out_infinite]"
              />
            </>

            {/* SEARCH BAR */}
            <div className="absolute md:left-[40%] xl:left-[42%] top-[30%] translate-x-[10%] -translate-y-[10%] flex items-center gap-3 xl:gap-5 bg-white/5 backdrop-blur-[5px] border border-white/30 rounded-full px-3 py-2 xl:px-4 xl:py-2 shadow-lg z-20">

              <span className="text-white text-sm lg:text-base xl:text-2xl whitespace-nowrap tracking-wide font-gilroy">
                www.thecodingstudio.in
              </span>

              <div className="relative flex h-8 w-8 xl:h-12 xl:w-12 items-center justify-center rounded-full bg-purple">

                <img
                  src={SearchIcon}
                  alt="search"
                  className="absolute w-4 h-4 xl:w-6 xl:h-6"
                />

              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  )
}

export default ChooseUs